import { render, staticRenderFns } from "./SliderTumbs.vue?vue&type=template&id=39e2d9f8&"
import script from "./SliderTumbs.vue?vue&type=script&lang=js&"
export * from "./SliderTumbs.vue?vue&type=script&lang=js&"
import style0 from "./SliderTumbs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports